import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIOS } from "../data/content";

export const Testimonios = () => (
  <section
    id="testimonios"
    data-testid="testimonios-section"
    className="relative bg-cream py-20 sm:py-28 lg:py-36"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead
        num="05"
        eyebrow="Respaldo"
        title="Testimonios"
        testId="testimonios-head"
      />

      <div className="mt-16 grid gap-5 md:grid-cols-2">
        {TESTIMONIOS.map((t, i) => (
          <Reveal key={t.author} delay={0.08 * i}>
            <figure
              data-testid={`testimonio-card-${i + 1}`}
              className="group flex h-full flex-col border border-cafe-line bg-white p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1 hover:border-cafe hover:shadow-xl hover:shadow-cafe-dark/10 sm:p-10"
            >
              <span
                aria-hidden="true"
                className="select-none font-display text-7xl font-semibold leading-[0.6] text-cafe"
              >
                &ldquo;
              </span>
              <blockquote className="mt-6 flex-1 font-display text-lg italic leading-relaxed text-cafe-dark sm:text-xl">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-cafe-line pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cafe-dark font-display text-sm font-semibold text-white">
                  {t.author.replace(/^(Ing\.|Lic\.)\s*/, "").charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-cafe-dark">{t.author}</span>
                  <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-cafe-muted">
                    {t.role}
                  </span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
